// ==============================|| OVERRIDES - CARD CONTENT ||============================== //

export default function CardContent(theme) {
  return {
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 20,
          '&:last-child': {
            paddingBottom: 20
          },
          // Phones: tighter, so content gets the narrow width (tablet / desktop: 20px).
          [theme.breakpoints.down('sm')]: {
            padding: 12,
            '&:last-child': {
              paddingBottom: 12
            }
          }
        }
      }
    }
  };
}
